<template>
  <div class="otp-pay">
    <!-- 加载中 -->
    <div class="otp-loading" v-if="isLoading">
      <div class="otp-loading-img-box">
        <img class="otp-loading-img" src="@/assets/prokash/pending.gif" alt="" />
      </div>
      <div class="otp-loading-text">Please wait...</div>
    </div>

    <!-- 错误 -->
    <div class="otp-over fail" v-if="isFailed && !isConfirming">
      <div class="otp-over-icon">✕</div>
      <div class="otp-over-text">Payment Failed</div>
      <div class="otp-over-desc">{{ failMessage }}</div>
      <button class="otp-over-btn" @click="$emit('expired')">Close</button>
    </div>

    <!-- OTP 输入页 -->
    <div class="otp-container" v-if="!isLoading && !isFailed && !isConfirming && !isOver">
      <div class="otp-header">
        <div class="otp-title">SMS Verification</div>
        <div class="otp-desc">Please enter the 6-digit verification code sent to your phone <b>{{ userMobileDisplay }}</b></div>
      </div>

      <div class="otp-amount-box">
        <div class="otp-amount-label">Amount</div>
        <div class="otp-amount-value">
          <span>{{ currencyCode }}</span>
          <span class="otp-amount-num">{{ formattedPaymentAmount }}</span>
        </div>
      </div>

      <div class="otp-input-box">
        <input
          v-model="otpCode"
          class="otp-input"
          type="tel"
          maxlength="6"
          placeholder="Enter OTP code"
          @input="onOtpInput"
        />
      </div>

      <div class="otp-submit-btn" @click="submitOtp" :class="{ disabled: otpCode.length < 6 || submitting }">
        <span>{{ submitting ? 'Confirming...' : 'Confirm Payment' }}</span>
      </div>
    </div>

    <!-- 确认中 -->
    <div class="otp-pending" v-if="isConfirming">
      <div class="otp-pending-text">Verifying...</div>
      <div class="otp-pending-img-box">
        <img class="otp-pending-img" src="@/assets/prokash/pending.gif" alt="" />
      </div>
    </div>

    <!-- 成功 -->
    <div class="otp-over success" v-if="isOver">
      <div class="otp-over-icon">✓</div>
      <div class="otp-over-text">Payment Successful</div>
      <button class="otp-over-btn" @click="back">Close</button>
    </div>
  </div>
</template>

<script>
import logic from "./index.js";
export default {
  name: "TwoPhaseOtpComputer",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
.otp-pay {
  max-width: 450px;
  margin: 40px auto;
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 2px 20px rgba(0,0,0,0.08);
}

.otp-loading {
  text-align: center;
  padding: 20px 0;

  .otp-loading-img-box {
    display: flex;
    justify-content: center;

    .otp-loading-img {
      width: 200px;
      height: 200px;
    }
  }

  .otp-loading-text {
    font-size: 16px;
    color: #555;
    transform: translateY(-50px);
  }
}

.otp-container {
  .otp-header {
    text-align: center;
    margin-bottom: 28px;

    .otp-title {
      font-size: 22px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }

    .otp-desc {
      font-size: 13px;
      color: #888;
      line-height: 1.4;
    }
  }

  .otp-amount-box {
    text-align: center;
    margin-bottom: 28px;

    .otp-amount-label {
      font-size: 13px;
      color: #888;
      margin-bottom: 4px;
    }

    .otp-amount-value {
      font-size: 16px;
      color: #524535;
      font-weight: 500;
    }

    .otp-amount-num {
      font-size: 20px;
      color: #DC811D;
      margin-left: 6px;
    }
  }

  .otp-input-box {
    margin-bottom: 28px;

    .otp-input {
      width: 100%;
      height: 52px;
      border: 2px solid #e8e8e8;
      border-radius: 10px;
      padding: 0 20px;
      font-size: 22px;
      text-align: center;
      letter-spacing: 10px;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.2s;

      &:focus {
        border-color: #DC811D;
      }

      &::placeholder {
        letter-spacing: 0;
        font-size: 14px;
        color: #ccc;
      }
    }
  }

  .otp-submit-btn {
    width: 100%;
    height: 50px;
    background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    color: #996a30;
    transition: opacity 0.2s;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .otp-resend {
    text-align: center;
    margin-top: 18px;
    font-size: 12px;
    color: #aaa;
  }
}

.otp-pending {
  text-align: center;
  padding: 20px 0;

  .otp-pending-text {
    font-size: 20px;
    font-weight: 500;
    color: #555;
  }

  .otp-pending-img-box {
    display: flex;
    justify-content: center;
    transform: translateY(-30px);

    .otp-pending-img {
      width: 250px;
      height: 250px;
    }
  }
}

.otp-over {
  text-align: center;
  padding: 20px 0;

  .otp-over-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #fff;
  }

  &.success .otp-over-icon {
    background: #52c41a;
  }

  &.fail .otp-over-icon {
    background: #ff4d4f;
  }

  .otp-over-text {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  &.success .otp-over-text {
    color: #52c41a;
  }

  &.fail .otp-over-text {
    color: #ff4d4f;
  }

  .otp-over-desc {
    font-size: 14px;
    color: #888;
    margin-bottom: 20px;
  }

  .otp-over-btn {
    width: 100%;
    height: 45px;
    background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #996a30;
    cursor: pointer;
  }
}
</style>
